function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M21.711 4.236a.983.983 0 0 1 .289.698v19.08c0 .545-.44.986-.985.986H.985A.985.985 0 0 1 0 24.013V.987C0 .44.44 0 .985 0h16.09a.98.98 0 0 1 .696.29zm-9.531 9.217c0-.82-.567-1.26-1.478-1.26H9.297v2.543h1.44c.911 0 1.443-.547 1.443-1.26zm-1.324-2.906c1.973 0 3.166 1.171 3.166 2.86v.025c0 1.915-1.488 2.908-3.342 2.908H9.297v2.483H7.478v-8.276zm6.22-8.163l.015 2.534 2.529.014zm2.954 20.652V5.923l-.005.987-3.919-.02a.987.987 0 0 1-.98-.982l-.022-3.928.985-.006H1.97v21.062z"
})));

var SvgIconFilePowerpoint = function SvgIconFilePowerpoint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 22 25",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFilePowerpoint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-file-powerpoint.46ca2c6b.svg";
export { ForwardRef as ReactComponent };